/** Wallet + theme only (inventory / marketplace pages — no NFT grid). */
import "./layout-shell.css";
import "./styles.css";
import { initComingSoonNavLinks, initMobileNav } from "./navMobile.js";
import { initThemeLamp } from "./theme.js";
import { initWalletConnect } from "./wallet/reown.js";
import { mountProdEnvBannerIfNeeded, warnStakingEnvIfIncomplete } from "./lib/env.js";

initThemeLamp();
initMobileNav();
initComingSoonNavLinks();
warnStakingEnvIfIncomplete();
mountProdEnvBannerIfNeeded();
void initWalletConnect();

const path = typeof window !== "undefined" ? window.location.pathname : "";
if (path.includes("inventory")) {
  import("./inventory-ui.js").then((m) => void m.initInventoryPage());
} else if (path.includes("marketplace")) {
  import("./marketplace-ui.js").then((m) => void m.initMarketplacePage());
}
